import removeInfoBarMessage from '../actions/removeInfoBarMessage';
import setIRMData from '../actions/setIRMData';
import infoBarStrings from 'owa-strings/owa-common-strings';
export default function removeProtection(viewState, templateId) {
    return {
        text: infoBarStrings.removeProtectionLink,
        action: function () {
            removeInfoBarMessage(viewState, templateId);
            setIRMData(viewState, null);
        },
    };
}
//# sourceMappingURL=removeProtection.js.map